import declare from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import dojoDateLocale from 'dojo/date/locale';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import HintBox from 'more/HintBox';
import template from './Container.html?raw';
export default declare("WidgetCollection.Occurrence.List.Container", [_WidgetBaseSP], {
        templateString: template,

        homePanel: null,
        table: null,
        jsonData: null,

        postMixInProperties: function () {
            this.inherited(arguments);
        },
        postCreate: function () {
            this.inherited(arguments);
            this.RequestManager.silentExceptions = true;
        },

        startup: function (bReload) {

            if (this.jsonData == null || bReload === true) {
                this.loadOccurrences();
                return;
            }

            this._renderTable();
        },

        loadOccurrences: function (entityID) {

            this.StandbyStart();

            var url = window.appRoot + "Occurrence/LoadOccurrenceListJSON";

            this.RequestManager.post(
                url,
                {
                    
                },
                lang.hitch(this, "_onLoadOccurrencesResponse"),
                lang.hitch(this, "_onLoadOccurrencesError"),
                false // sync
            );
        },

        _onLoadOccurrencesResponse: function (response) {
            this.StandbyStop();
            this.jsonData = JSON.parse(response);

            console.log("_onLoadOccurrencesResponse", this.jsonData)

            this._renderTable();
        },

        _onLoadOccurrencesError: function (error) {
            this.StandbyStop();

            alert(error.Message);
            //this.handleErrorResponse(error.Message);
        },

        tableFormatter: function (cell, formatterParams, onRendered) {

            var data = cell.getData();
            var value = cell.getValue();

            if (data.ref_vt_property.is_value_list === true) {
                for (var i = 0; i < data.ref_vt_property.EL_vt_property_value_vt_property.length; i++) {
                    var propValue = data.ref_vt_property.EL_vt_property_value_vt_property[i];

                    if (propValue.ID == value) {
                        return propValue.bezeichnung;
                    }
                }
            }

            return value;
        },

        tableFormatterDateTime: function (cell, formatterParams, onRendered) {

            var data = cell.getData();
            var value = cell.getValue();

            var date = new Date(value);

            console.log("tableFormatterDateTime", date, value);

            value = dojoDateLocale.format(date, { locale: 'de-de', datePattern: "dd.MM.yyyy", timePattern: "HH:mm" });

            return value;
        },

        //custom formatter definition
        tableBtnEdit: function(cell, formatterParams, onRendered){ //plain text value
            return "<div class='w3-padding-small w3-center mds-bg-gray mds-hover-dark'><i class='fa fa-pencil'></i></div>";
        },

        //column definition in the columns array
        

        _renderTable: function () {

            domConstruct.empty(this.domNode);

            if (this.jsonData == null || typeof (this.jsonData) == "undefined") {

                return;
            }

            this.table = new Tabulator(this.domNode, {
                data: this.jsonData,
                layout: "fitColumns",
                //height: "",
                columns: [
                    { title: "Nr", field: "Number", width: 90, editor: false },
                    {
                        title: "Datum", field: "Time", width: 110, editor: false, formatter: this.tableFormatterDateTime
                    },
                    { title: "Meldender", field: "ref_reporter.DispName", editor: false },
                    { title: "Meldungsart", field: "ref_occurrence_type.Name", width: 200, editor: false },
                    { title: "Kostenstelle", field: "ref_cost_center2.Cost_center", width: 100, editor: false },
                    { title: "Meldungsstatus", field: "ref_occurrence_status.description", width: 100, editor: false },
                    { title: "Rückmeldung", field: "feedback", editor: false },
                    { title: "Ationen", formatter: this.tableBtnEdit, width:50, align: "center", cellClick: this.clickTableEdit },
                    
                ]
                //cellEdited: lang.hitch(this, "_onPropertyEdited")
            });
        },

        clickTableEdit: function (evt, cell) {
            console.log("clickTableEdit", cell, cell.getRow().getData());
            var entityID = cell.getRow().getData().ID;

            this.homePanel.showOccurenceForm(entityID);
        }
        
    });
